import { render } from "./FinancialArea.vue?vue&type=template&id=725730c2&scoped=true"
import script from "./FinancialArea.vue?vue&type=script&lang=js"
export * from "./FinancialArea.vue?vue&type=script&lang=js"

import "./FinancialArea.vue?vue&type=style&index=0&id=725730c2&scoped=true&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-725730c2"]])

export default __exports__